import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_QUE_RADIO_BUTTON_CONFIGURATION = gql`
  mutation createRadioButtonQuesConfigRequest(
    $allowUserGeneratedResponses: Boolean
    $canModify: Boolean!
    $description: String!
    $projectId: String!
    $title: String!
  ) {
    questionConfiguration {
      createQuestionConfiguration(
        baseConfiguration: { description: $description, projectId: $projectId }
        questionConfigurationRadio: {
          allowUserGeneratedResponses: $allowUserGeneratedResponses
          canModify: $canModify
          questionResponseSet: { title: $title }
        }
      ) {
        id
        ... on Radio {
          id
          responseSetID
          responseSet {
            id
            availableResponses {
              id
              label
              questionResponseSetId
              value
            }
          }
        }
      }
    }
  }
`;

const createRadioButtonQuesConfigRequest = ({
  allowUserGeneratedResponses,
  canModify,
  description,
  projectId,
  onError,
  onSuccessResult,
  title,
}) => (
  <Mutation mutation={CREATE_QUE_RADIO_BUTTON_CONFIGURATION}>
    {(createAppVersion, { loading, error, data }) => {
      const variables = {
        allowUserGeneratedResponses,
        canModify,
        description,
        projectId,
        title,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(
          data.questionConfiguration.createQuestionConfiguration.id,
          data
        );
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createAppVersion}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createRadioButtonQuesConfigRequest.propTypes = {
  // eslint-disable-next-line react/boolean-prop-naming
  canModify: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  // eslint-disable-next-line react/boolean-prop-naming
  allowUserGeneratedResponses: PropTypes.bool,
};

createRadioButtonQuesConfigRequest.defaultProps = {
  allowUserGeneratedResponses: false,
};

export default createRadioButtonQuesConfigRequest;
